import { QUESTION_POOL_MODE } from '@coconut/constants/modeOfTutorHome';

export const types = {
  STORE_PREVIOUS_LOCATION: 'STORE_PREVIOUS_LOCATION',
  SET_MODE_OF_TUTOR_HOME: 'SET_MODE_OF_TUTOR_HOME',
};

export const storePreviousLocation = (location) => ({
  type: types.STORE_PREVIOUS_LOCATION,
  payload: location,
});

export const setModeOfTutorHome = (mode) => ({
  type: types.SET_MODE_OF_TUTOR_HOME,
  payload: {
    mode,
  },
});

const INIT_STATE = {
  previous: { pathname: '/' },
  modeOfTutorHome: QUESTION_POOL_MODE,
};

export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case types.STORE_PREVIOUS_LOCATION: {
      return {
        ...state,
        previous: action.payload,
      };
    }
    case types.SET_MODE_OF_TUTOR_HOME: {
      return {
        ...state,
        modeOfTutorHome: action.payload.mode,
      };
    }
    default:
      return state;
  }
}

export const getPreviousLocation = (state) => state.location.previous;
export const getModeOfTutorHome = (state) => state.location.modeOfTutorHome;



// WEBPACK FOOTER //
// ./src/services/redux/location.js